import vocabTQVMPracticeInstructionStart from '../sounds/vocab_tqvm_practice_instruction_start.mp3';
import vocabTQVMPracticeInstructionStartSpanish from '../sounds/spanish/tqvm_practice_screen_active_state.mp3';
import vocabTQVMPracticeReadyInstruction from '../sounds/vocab_tqvm_practice_ready_instruction.mp3';
import vocabTQVMPracticeReadyInstructionSpanish from '../sounds/spanish/tqvm_practice_screen_ready_state.mp3';
import vocabTQVMQuestionInstructionReplay from '../sounds/vocab_tqvm_question_instruction_replay.mp3';
import vocabTQVMQuestionInstructionReplaySpanish from '../sounds/spanish/selecciona_pulgar.mp3';
import vocabFITBPracticeInstructionStart from '../sounds/vocab_fitb_practice_instruction_start.mp3';
import vocabFITBPracticeInstructionStartSpanish from '../sounds/spanish/fitb_practice_screen_active_state.mp3';
import vocabFITBInstructionReplay from '../sounds/vocab_fitb_practice_instruction_replay.mp3';
import vocabFITBInstructionReplaySpanish from '../sounds/spanish/what_word_fills_in_the_blank.mp3';
import vocabFITBPracticeReadyInstruction from '../sounds/vocab_fitb_practice_ready_instruction.mp3';
import vocabFITBPracticeReadyInstructionSpanish from '../sounds/spanish/fitb_practice_screen_ready_state.mp3';
import vocabBDPracticeInstructionStart from '../sounds/vocab_bd_practice_instruction_start.mp3';
import vocabBDPracticeInstructionStartSpanish from '../sounds/spanish/bd_practice_screen_active_state.mp3';
import vocabBDPracticeReadyInstruction from '../sounds/vocab_bd_practice_ready_instruction.mp3';
import vocabBDPracticeReadyInstructionSpanish from '../sounds/spanish/bd_practice_screen_ready_state.mp3';
import vocabPracticeClickOk from '../sounds/click_ok.mp3';
import vocabPracticeClickOkSpanish from '../sounds/spanish/clic_continuare.mp3';

// Alyx English Audios
import vocabTQVMPracticeInstructionStartAlyx from '../sounds/alyx/english/vocab_tqvm_practice_instruction_start_alyx.mp3';
import vocabTQVMPracticeReadyInstructionAlyx from '../sounds/alyx/english/vocab_tqvm_practice_ready_instruction_alyx.mp3';
import vocabTQVMQuestionInstructionReplayAlyx from '../sounds/alyx/english/vocab_tqvm_question_instruction_replay_alyx.mp3';
import vocabFITBPracticeInstructionStartAlyx from '../sounds/alyx/english/vocab_fitb_practice_instruction_start_alyx.mp3';
import vocabFITBInstructionReplayAlyx from '../sounds/alyx/english/vocab_fitb_practice_instruction_replay_alyx.mp3';
import vocabFITBPracticeReadyInstructionAlyx from '../sounds/alyx/english/vocab_fitb_practice_ready_instruction_alyx.mp3';
import vocabBDPracticeInstructionStartAlyx from '../sounds/alyx/english/vocab_bd_practice_instruction_start_alyx.mp3';
import vocabBDPracticeReadyInstructionAlyx from '../sounds/alyx/english/vocab_bd_practice_ready_instruction_alyx.mp3';
import vocabPracticeClickOkAlyx from '../sounds/alyx/english/click_ok_alyx.mp3';

// Alyx Spanish Audios
import vocabTQVMPracticeInstructionStartSpanishAlyx from '../sounds/alyx/spanish/tqvm_practice_screen_active_state_Alyx.mp3';
import vocabTQVMPracticeReadyInstructionSpanishAlyx from '../sounds/alyx/spanish/tqvm_practice_screen_ready_state_Alyx.mp3';
import vocabTQVMQuestionInstructionReplaySpanishAlyx from '../sounds/alyx/spanish/selecciona_pulgar_Alyx.mp3';
import vocabFITBPracticeInstructionStartSpanishAlyx from '../sounds/alyx/spanish/fitb_practice_screen_active_state_Alyx.mp3';
import vocabFITBInstructionReplaySpanishAlyx from '../sounds/alyx/spanish/what_word_fills_in_the_blank_Alyx.mp3';
import vocabFITBPracticeReadyInstructionSpanishAlyx from '../sounds/alyx/spanish/fitb_practice_screen_ready_state_Alyx.mp3';
import vocabBDPracticeInstructionStartSpanishAlyx from '../sounds/alyx/spanish/bd_practice_screen_active_state_Alyx.mp3';
import vocabBDPracticeReadyInstructionSpanishAlyx from '../sounds/alyx/spanish/bd_practice_screen_ready_state_Alyx.mp3';
import vocabPracticeClickOkSpanishAlyx from '../sounds/alyx/spanish/clic_continuare_Alyx.mp3';
import { selectAvatarAudio } from '../common/alex/AlexUtils';
import { LANGUAGES } from '../common/localization';

export const VOCAB_AUDIO_INSTRUCTIONS = {
    [LANGUAGES.ENGLISH]: {
        vocabTQVMPracticeInstructionStart: selectAvatarAudio(
            vocabTQVMPracticeInstructionStart,
            vocabTQVMPracticeInstructionStartAlyx,
        ),
        vocabTQVMPracticeReadyInstruction: selectAvatarAudio(
            vocabTQVMPracticeReadyInstruction,
            vocabTQVMPracticeReadyInstructionAlyx,
        ),
        vocabTQVMQuestionInstructionReplay: selectAvatarAudio(
            vocabTQVMQuestionInstructionReplay,
            vocabTQVMQuestionInstructionReplayAlyx,
        ),
        vocabFITBPracticeInstructionStart: selectAvatarAudio(
            vocabFITBPracticeInstructionStart,
            vocabFITBPracticeInstructionStartAlyx,
        ),
        vocabFITBInstructionReplay: selectAvatarAudio(
            vocabFITBInstructionReplay,
            vocabFITBInstructionReplayAlyx,
        ),
        vocabFITBPracticeReadyInstruction: selectAvatarAudio(
            vocabFITBPracticeReadyInstruction,
            vocabFITBPracticeReadyInstructionAlyx,
        ),
        vocabBDPracticeInstructionStart: selectAvatarAudio(
            vocabBDPracticeInstructionStart,
            vocabBDPracticeInstructionStartAlyx,
        ),
        vocabBDPracticeReadyInstruction: selectAvatarAudio(
            vocabBDPracticeReadyInstruction,
            vocabBDPracticeReadyInstructionAlyx,
        ),
        clickOk: selectAvatarAudio(vocabPracticeClickOk, vocabPracticeClickOkAlyx),
    },
    [LANGUAGES.SPANISH]: {
        vocabTQVMPracticeInstructionStart: selectAvatarAudio(
            vocabTQVMPracticeInstructionStartSpanish,
            vocabTQVMPracticeInstructionStartSpanishAlyx,
        ),
        vocabTQVMPracticeReadyInstruction: selectAvatarAudio(
            vocabTQVMPracticeReadyInstructionSpanish,
            vocabTQVMPracticeReadyInstructionSpanishAlyx,
        ),
        vocabTQVMQuestionInstructionReplay: selectAvatarAudio(
            vocabTQVMQuestionInstructionReplaySpanish,
            vocabTQVMQuestionInstructionReplaySpanishAlyx,
        ),
        vocabFITBPracticeInstructionStart: selectAvatarAudio(
            vocabFITBPracticeInstructionStartSpanish,
            vocabFITBPracticeInstructionStartSpanishAlyx,
        ),
        vocabFITBInstructionReplay: selectAvatarAudio(
            vocabFITBInstructionReplaySpanish,
            vocabFITBInstructionReplaySpanishAlyx,
        ),
        vocabFITBPracticeReadyInstruction: selectAvatarAudio(
            vocabFITBPracticeReadyInstructionSpanish,
            vocabFITBPracticeReadyInstructionSpanishAlyx,
        ),
        vocabBDPracticeInstructionStart: selectAvatarAudio(
            vocabBDPracticeInstructionStartSpanish,
            vocabBDPracticeInstructionStartSpanishAlyx,
        ),
        vocabBDPracticeReadyInstruction: selectAvatarAudio(
            vocabBDPracticeReadyInstructionSpanish,
            vocabBDPracticeReadyInstructionSpanishAlyx,
        ),
        clickOk: selectAvatarAudio(vocabPracticeClickOkSpanish, vocabPracticeClickOkSpanishAlyx),
    },
};

export const VOCAB_GRADES_WITH_AUTOPLAY = ['KG', '01'];

export const TQVM_GRADES_WITH_INTERSTITIAL = ['KG'];
export const FITB_GRADES_WITH_INTERSTITIAL = ['01'];
